module.exports = __webpack_public_path__ + "media/images/convenios/cons_prof_vet-0d873bba390e488f352ce2d13188aa70.jpg";